var socialHubVent = _.extend( {}, Backbone.Events );
var socialHubOldScroll = null;

var socialHubModel = Backbone.Model.extend({
  defaults: {
    popup: {},
    preview: []
  },

  initialize: function(){
    if (!this.get('popup').sharing_url) {
      var popup = this.get('popup');
      popup.sharing_url = window.location.href;
      this.set('popup', popup);
    }
  },
});

var socialHubCollection = Backbone.Collection.extend({
  model: socialHubModel
});

var socialHubItem = Backbone.View.extend({
  tagName: 'div',
  className: 'socialHub__item',
  template: _.template(jQuery('#socialHubItem-tpl').html()),
  events: {
    'click': 'openPopup'
  },

  initialize: function() {
    if (this.model.get('thumb')) {
      this.$el.addClass('has-thumb');
    }

    this.render();
    return this;
  },

  render: function() {
    this.$el.html(this.template(this.model.toJSON()));
    return this;
  },

  openPopup: function(e) {
    if (!this.model.get('thumb')) {
      return;
    }

    Backbone.history.navigate(socialHubData.base_url + "?hub=" + this.model.get('permalink'), {
      trigger: true
    });

    socialHubVent.trigger('hub:view', this.model);
  },
});

var socialHubItems = Backbone.View.extend({
  el: '#socialHub',

  initialize: function() {
    this.collection.each(this.renderItem, this);
  },

  renderItem: function(model, i) {
    var item = new socialHubItem({
      model: model
    });
    this.$el.append(item.$el);
  },
});

var modalPopup = Backbone.View.extend({
  tagName: 'div',
  className: 'modalPopup',
  template: _.template(jQuery('#modalPopup-tpl').html()),

  events: {
    'click .modalPopup__close' : 'close',
    'click .share-bttns a': 'openShareWindow'
  },

  initialize: function(){
    socialHubVent.once('hub:preRender', jQuery.proxy(this.preRender, this));
    socialHubVent.once('hub:close', jQuery.proxy(this.closeOnRouteChange, this));

    this.render();

    return this;
  },

  render: function(){
    this.$el.html(this.template(this.model.toJSON()));
    getSharesCountForURL(this.$el.find('.total-share-count'), this.model.get('popup').sharing_url);
    return this;
  },

  close: function(e){
    var socialHubOldScroll = jQuery(window).scrollTop();

    Backbone.history.navigate(socialHubData.base_url, { trigger: false });

    jQuery(window).scrollTop(socialHubOldScroll);
    this.removeView();
  },

  removeView: function(){
    this.unbind();
    this.$el.remove();
  },

  preRender: function(model){
    this.removeView();
  },

  closeOnRouteChange: function(route){
    if (!route || route !== this.model.get('permalink')) {
      this.removeView();
    }
  },

  openShareWindow: function(e){
    window.open(e.currentTarget.href, 'sharer','toolbar=0,status=0,width=626,height=436');
    return false;
  },
});

var socialHubHistory = Backbone.Router.extend({
  routes: {
    "": "closeHub",
  },

  initialize: function(){
    this.route(socialHubData.base_url + "?hub=:hub", 'openHub');
  },

  closeHub: function(e){
    socialHubVent.trigger('hub:close');
  },


  openHub: function(hubName){
    socialHubVent.trigger('hub:close', hubName);

    var hubs = new socialHubCollection(socialHubData.items);

    var hubModel = hubs.findWhere({permalink: hubName});

    if (hubModel) {
      socialHubVent.trigger('hub:preRender', hubModel);

      var hubPopup = new modalPopup({
        model: hubModel
      });

      jQuery('body').append(hubPopup.$el);
    }
  },
});

jQuery(document).ready(function($) {
  new socialHubItems({
    collection: new socialHubCollection(socialHubData.items)
  });

  var router = new socialHubHistory();

  Backbone.history.start({
    pushState: true
  });
});


function formatCounter(num) {
  num = Number(num);

  if (num >= 1000000) {
    return (num / 1000000).toFixed(2) + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(2) + 'K';
  }
  return num;
}

function getSharesCountForURL(el, url) {
  var $ = jQuery;
  var totalCount = 0;

  $.getJSON('https://graph.facebook.com/?id=' + url, function(data){
    if (data.share) {
      totalCount += data.share.share_count;
      el.html(formatCounter(totalCount));
    }
  });

  $.ajax({
    dataType: 'jsonp',
    url: 'https://api.tumblr.com/v2/share/stats?url=' + url,
    success: function(data){
      totalCount += data.response.note_count;
      el.html(formatCounter(totalCount));
    }
  });
}